// removed by extract-text-webpack-plugin
module.exports = {"icon":"src-node_modules-kts-platform-frame-display-components-Icon-index__icon--2kNNj"};


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-platform-frame/display/components/Icon/index.scss
// module id = 4398
// module chunks = 0